import { defineComponent as _defineComponent } from 'vue';
import License from "@/components/License/License.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowLicense',
    props: {
        licenseId: { default: null }
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, License };
    }
});
